import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'menu', 'Menu', [["path",{"d":"M4 8l16 0"}],["path",{"d":"M4 16l16 0"}]]);